import { render, staticRenderFns } from "./tags-popup.vue?vue&type=template&id=2a220529&scoped=true"
import script from "./tags-popup.vue?vue&type=script&lang=js"
export * from "./tags-popup.vue?vue&type=script&lang=js"
import style0 from "./tags-popup.vue?vue&type=style&index=0&id=2a220529&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a220529",
  null
  
)

export default component.exports